var map = {
	"./ad.svg": "104c",
	"./al.svg": "68ab",
	"./am.svg": "ace0",
	"./at.svg": "2dd0",
	"./ba.svg": "089b",
	"./be.svg": "a9a0",
	"./bg.svg": "a7fe",
	"./by.svg": "aaad",
	"./ca.svg": "0766",
	"./ch.svg": "c281",
	"./cn.svg": "4805",
	"./cy.svg": "bcbf",
	"./cz.svg": "e543",
	"./de.svg": "8b52",
	"./dk.svg": "a14d",
	"./ee.svg": "17dd",
	"./es.svg": "7229",
	"./fi.svg": "da45",
	"./fr.svg": "adc2",
	"./gb.svg": "aa6d",
	"./gi.svg": "cbac",
	"./gr.svg": "64e6",
	"./hr.svg": "c9ee",
	"./hu.svg": "7791",
	"./ie.svg": "134b",
	"./is.svg": "1f26",
	"./it.svg": "e1bb",
	"./jp.svg": "4357",
	"./li.svg": "2819",
	"./lt.svg": "e296",
	"./lu.svg": "f0b8",
	"./lv.svg": "f16c",
	"./mc.svg": "5fe9",
	"./mk.svg": "7822",
	"./mt.svg": "3063",
	"./nl.svg": "99c1",
	"./no.svg": "b189",
	"./pl.svg": "bd10",
	"./pt.svg": "93be",
	"./ro.svg": "6d19",
	"./ru.svg": "20c6",
	"./se.svg": "7543",
	"./si.svg": "459d",
	"./sk.svg": "faea",
	"./sm.svg": "2a79",
	"./ua.svg": "a65e",
	"./us.svg": "b94e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d1c";